




















import { Vue, Component, Prop, Ref, Emit, Watch } from 'vue-property-decorator'
import { FormDef, FieldDef } from '@/types'
import { mapping } from '@/config/form'

@Component({
  components: { }
})
export default class QueryForm extends Vue {
  @Prop({ type: String, default: '查询列表' }) title!: string

  @Prop({ type: String, default: '' }) subtitle!: string

  @Prop({ type: Number, default: 8 }) span!: number

  @Prop({ type: Number, default: 6 }) xl!: number

  @Prop(Array) def!: FieldDef[]

  @Prop() resetCallback: any

  @Prop({ default: () => ({}) }) form!: Record<string | number, any>

  @Prop({ type: Boolean, default: true }) mapping!: boolean

  @Prop() mappingOptions!: any

  @Emit() query (params: Record<string | number, any>) { /* */ }

  @Ref() fm!: any

  expand = false

  single = false

  get formDef (): FormDef {
    const vm: any = this as any
    return {
      options: {
        labelPosition: 'top',
        size: 'small'
      },
      controls: [
        {
          type: 'grid',
          columns: (this.def || []).map(v => ({ ...grid(v), controls: [(v as any).def || v] })),
          options: {
            gutter: 72
          }
        }
      ]
    }
    function grid (row: any) {
      return {
        span: (row as any).span || vm.span,
        xl: (row as any).xl || (row as any).span || vm.xl
      }
    }
  }

  get collapseCls () {
    return !this.expand ? (this as any).$style.collapse : ''
  }

  onQuery () {
    this.fm.submit().then((params: any) => {
      this.query(this.mapping ? mapping(params, this.mappingOptions) : params)
    })
  }

  onReset () {
    this.fm.reset()
    this.resetCallback && this.resetCallback()
  }

  onCollapse () {
    const target = this.$el.querySelectorAll('.el-form>.el-row>.el-col')
    if (!target || target.length < 1) return
    const num = document.body.clientWidth >= 1680 ? 8 : 6
    if (target.length <= num) this.single = true
    else this.single = false
    target.forEach((v: any, i: any) => {
      if (this.expand) v.hidden = false
      else {
        if (i < num) v.hidden = false
        else v.hidden = true
      }
    })
    if (this.$el && this.expand) this.$el.scrollIntoView()
  }

  @Watch('expand', { immediate: true }) expandChange () {
    this.$nextTick(() => {
      this.onCollapse()
    })
  }

  mounted () {
    const handler = window.addEventListener('resize', this.onCollapse)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.onCollapse)
    })
  }
}
